// @flow
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'reactstrap';

import UpsellLodge from './UpsellLodge';
import { appendHoneyGuide } from '../../../lib/utils';
import { Order } from '../Common';
import { WhitePanel, Sticky, Page } from '../../../components';
import { useSelector } from '../../../redux/reduxDB';
import { getCartData } from '../../../redux/cart';

export default function CartListings() {
  const [invoice, orderIds] = useSelector(getCartData);

  return (
    <Page title={appendHoneyGuide('Cart')}>
      <Container>
        {orderIds && orderIds.length > 0 && invoice.status.toLowerCase() === 'pending' ? (
          <React.Fragment>
            <Row>
              <Col lg={{ size: 4, order: 2 }} xs="12">
                <Sticky>
                  <CheckoutButton currency={invoice.currency} amount={invoice.amount} />
                </Sticky>
              </Col>
              <Col lg={{ size: 8, order: 1 }} xs="12">
                <WhitePanel className="cart">
                  <h1 className="cart-title">Your Cart - Payment Pending</h1>
                  {orderIds.map(id => (
                    <Order key={id} orderId={id} shouldShowDelete />
                  ))}
                  <AddLodge />
                </WhitePanel>
              </Col>
            </Row>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Row>
              <Col lg="12" xs="12">
                <WhitePanel>
                  <AddLodge />
                </WhitePanel>
              </Col>
            </Row>
            <UpsellLodge />
          </React.Fragment>
        )}
      </Container>
    </Page>
  );
}

const CheckoutButton = withRouter(props => {
  const { currency, amount, location } = props;

  return (
    <WhitePanel className="total-amt-wrap">
      <div className="total-amt">
        <p>
          Subtotal:{' '}
          <span>
            {currency} {amount.toLocaleString()}
          </span>
        </p>
        <a href={`${location.pathname}/payment`}>
          <Button color="yellow" id="cart-checkout-btn">PROCEED TO CHECKOUT</Button>
        </a>
      </div>
    </WhitePanel>
  );
});

function AddLodge() {
  return (
    <div className="other-lodge">
      <h3 className="message">
        <span>Add lodges to your cart</span>
      </h3>
      <Link to="/lodges">
        <Button color="yellow" className="upsell">
          Search Lodges
        </Button>
      </Link>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Cart/Listings/CartListings.js